export default {
  // Normalized panel data (to keep reactivity simpler)
  panels: {},
  panelSettings: {},
  panelInteractions: {},
  panelPages: {},
  panelIntervals: {},
  panelPaused: {},
  panelPausedInteractions: {},
  panelTypes: {},

  interactions: {},
  interactionHeights: {},
  pollingIntervals: {},
  instantPollResults: {},

  loadingInteractions: {},
  loadingInteractionsSuccess: {},
  loadingInteractionsFailed: {},
  loadingInteractionsError: {},
  hasMoreInteractions: {},

  threadId: null,
  threadChannel: null,
  threads: [],
  threadCounts: {},
  threadDialogVisible: false,
  loadingThreads: false,
  loadingThreadsSuccess: false,
  loadingThreadsFailed: false,
  loadingThreadsError: null,

  loadingPanels: false,
  loadingPanelsSuccess: false,
  loadingPanelsFailed: false,
  loadingPanelsError: null,

  mediaIsPlaying: [],

  galleryImages: [],
  galleryVisible: false,
  galleryIndex: 0,

  panelSettingsDialog: {
    id: null,
    name: '',
    color: '',
    columns: null,
    type: null,
    channelIds: [],
    campaignIds: [],
  },
  panelSettingsDialogVisible: false,
  twitterTrends: [],

  searchTerm: null,
  searchResults: [],
  searchCount: 0,
  searching: false,
  searchFields: null,

  loadingExportFiles: false,

  updatePanelOrderSuccess: false,
  updatePanelOrderFailure: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/interaction/state.js